import { render, staticRenderFns } from "./AppPhone.vue?vue&type=template&id=7fa71706&"
import script from "./AppPhone.vue?vue&type=script&lang=js&"
export * from "./AppPhone.vue?vue&type=script&lang=js&"
import style0 from "./AppPhone.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports